import { useState, useEffect } from "react";
import { isPlatform } from "@ionic/react";

import {
  Camera,
  CameraResultType,
  CameraSource,
  CameraDirection,
  Photo
} from "@capacitor/camera";
import { Filesystem, Directory } from "@capacitor/filesystem";
import { Storage } from "@capacitor/storage";
import { Capacitor } from "@capacitor/core";
export interface UserPhoto {
    filepath: string;
    webviewPath?: string;
    base64Data : string;
}
const PHOTO_STORAGE = "photos";

export function usePhotoGallery() {
    const [photos, setPhotos] = useState<UserPhoto[]>([]);
    const PHOTO_STORAGE = "photos";
   
    const takePhoto = async () => {
     
      const cameraPhoto = await Camera.getPhoto({
        resultType: CameraResultType.Uri,
        source: CameraSource.Photos,
        //direction : CameraDirection.Rear,
        //preserveAspectRatio : true,
        width : 800,
        height : 600,
        //allowEditing: true,
        quality: 100
      });
    
      const fileName = new Date().getTime() + '.jpeg';
      const savedFileImage = await savePicture(cameraPhoto, fileName);
      const newPhotos = [savedFileImage, ...photos];
      setPhotos(newPhotos);
      Storage.set({ key: PHOTO_STORAGE, value: JSON.stringify(newPhotos) });
       
    }
    const deletePhoto = async (photo: UserPhoto) => {
      // Remove this photo from the Photos reference data array
      const newPhotos = photos.filter(p => p.filepath !== photo.filepath);
    
      // Update photos array cache by overwriting the existing photo array
      Storage.set({key: PHOTO_STORAGE, value: JSON.stringify(newPhotos) });
    
      // delete photo file from filesystem
      const filename = photo.filepath.substr(photo.filepath.lastIndexOf('/') + 1);
      await Filesystem.deleteFile({
        path: filename,
        directory: Directory.Data
      });
      setPhotos(newPhotos);
    };
    const savePicture = async (photo: Photo, fileName: string): Promise<UserPhoto> => {
        const base64Data = await base64FromPath(photo.webPath!);
        const savedFile = await Filesystem.writeFile({
          path: fileName,
          data: base64Data,
          directory: Directory.Data
        });
      
        // Use webPath to display the new image instead of base64 since it's
        // already loaded into memory
        return {
            filepath: fileName,
            webviewPath: photo.webPath,
            base64Data : base64Data
        };
      };
      useEffect(() => {
        /*const loadSaved = async () => {
          const { value } = await Storage.get({ key: PHOTO_STORAGE });
          const photosInStorage = (value ? JSON.parse(value) : []) as UserPhoto[];
      
          for (let photo of photosInStorage) {
            const file = await Filesystem.readFile({
              path: photo.filepath,
              directory: Directory.Data,
            });
            console.log("Load Save");
            // Web platform only: Load the photo as base64 data
            photo.webviewPath = `data:image/jpeg;base64,${file.data}`;
          }
          setPhotos(photosInStorage);
        };
        loadSaved();*/
      }, []);

      async function base64FromPath(path: string): Promise<string> {
        const response = await fetch(path);
        const blob = await response.blob();
        return new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onerror = reject;
          reader.onload = () => {
            if (typeof reader.result === 'string') {
              resolve(reader.result);
            } else {
              reject('method did not return a string')
            }
          };
          reader.readAsDataURL(blob);
        });
      }
      return {
        photos,
        takePhoto,
        deletePhoto
      };

      

    };

   
    
    



